import { useEffect } from 'react';
import { NOTIFICATION_TYPES, useNotifications } from '@namespace/notifications';
import { socketSubscribe, socketUnsubscribe } from '@namespace/socket';
import { BetLimitNotification } from '../../common/BetLimitNotification';
import { IHUB_NOTIFICATION_TYPES } from '../../constants';

const IHUB_NOTIFICATION = 'ihub_notification';

type OnIHubRgNotification = (notificationType: string) => void;

interface HubNotificationData {
  type: keyof typeof IHUB_NOTIFICATION_TYPES;
}

interface HubNotification {
  data: HubNotificationData;
  event: 'ihub_notification';
  message_id: string;
  service: 'ihub';
  timestamp: number;
  version: number;
}

type HandleIHubNotification = (payload: HubNotification) => void;

export const useGameRgSocketError = (
  onIHubNotification: OnIHubRgNotification
) => {
  const { customNotification } = useNotifications();

  const handleIHubNotification: HandleIHubNotification = ({ data }) => {
    if (data?.type) {
      if (data.type === IHUB_NOTIFICATION_TYPES.blocked_by_max_bet_limit) {
        customNotification({
          NotificationComponent: BetLimitNotification,
          timeout: null,
          message: {
            errorCode: data.type
          },
          notificationType: NOTIFICATION_TYPES.RG_SOCKET_MESSAGE
        });
        return;
      }
      onIHubNotification(data.type);
    }
  };

  useEffect(() => {
    socketSubscribe({
      name: IHUB_NOTIFICATION,
      types: [IHUB_NOTIFICATION],
      callback: handleIHubNotification
    });

    return () => {
      socketUnsubscribe(IHUB_NOTIFICATION);
    };
  }, []);
};
